/**
 * Si el link va a /cotizar, le agrega ?modelo=<slug> (y &version=<slug>) para
 * que el cotizador abra con ese modelo ya cargado. Respeta los parámetros que
 * ya traiga el link y no toca links a otras páginas ni externos.
 */
export function cotizarConModelo(url: string | null | undefined, modelo?: string | null, version?: string | null): string {
  const u = (url ?? '').trim();
  if (!u || !modelo) return u;
  const [sinAncla, ancla] = u.split('#');
  const [ruta, query = ''] = sinAncla.split('?');
  if (!/^\/cotizar\/?$/i.test(ruta)) return u;
  const params = new URLSearchParams(query);
  if (!params.has('modelo')) {
    params.set('modelo', modelo);
    if (version && !params.has('version')) params.set('version', version);
  }
  return `${ruta}?${params.toString()}${ancla !== undefined ? '#' + ancla : ''}`;
}

/** Slug del modelo que se está viendo según la URL (/modelo/:slug o /modelos/detail?model=slug). */
export function modeloDeUrl(url: string): string | null {
  const [ruta, query = ''] = url.split('#')[0].split('?');
  const m = ruta.match(/^\/modelo\/([^/]+)\/?$/);
  if (m) return decodeURIComponent(m[1]);
  if (/^\/modelos\/detail(-nuevo)?\/?$/.test(ruta)) return new URLSearchParams(query).get('model');
  return null;
}
